let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("jJc4I"), load("9sZ57"), load("a8f2N"), load("i6hfz"), load("bMgpg"), load("iBa9k"), load("d4MuV")]).then(() => parcelRequire('kBOGD'));